import { dirRtl } from './rtl.locstring.json';
import loc from 'owa-localize';
import RibbonButton from './RibbonButton';

import { Direction } from 'roosterjs-editor-types';
import { setDirection } from 'roosterjs-editor-api';

const rtl: RibbonButton = {
    key: 'rtl',
    title: () => loc(dirRtl),
    imageSrc: require('../svg/rtl.svg'),
    onExecute: plugin => setDirection(plugin.getEditor(), Direction.RightToLeft),
};

export default rtl;
